import { render } from "./issue.vue?vue&type=template&id=d0682c7a&scoped=true"
import script from "./issue.vue?vue&type=script&lang=js"
export * from "./issue.vue?vue&type=script&lang=js"

import "./issue.vue?vue&type=style&index=0&id=d0682c7a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d0682c7a"

export default script